export const embedProviderButtonsTestIds = {
  googleSheets: 'embed-provider-button-google-sheets',
  microsoftExcel: 'embed-provider-button-microsoft-excel',
};
